// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass, WithTagName } from "./Dom";
import { distributeEventDownHierarchy } from "./Event";
import { FileUploadState } from "./WebApp.File_.Store";
import { ThumbnailRenderer } from "./WebApp.File_.Thumbnail.Renderer";
import { application } from "./WebApp.Instance";
import { FileUploadStatusChangedEvent } from "./WebApp.Upload.Center";
import { ProgressBar } from "./WebSite.Form.Field.File_";
import { FileDropZone } from "./WebSite.Page.Component.DropZone.File_";
import { Labels } from "./WebSite.Page.Component";

export class FileUploadedEvent {
  constructor(target, data) {
    this.target = target;
    this.data = data;
  }
}

function UploadRow(element, file) {
  this.build = function () {
    this.fileNameCell = this.element.appendChild(document.createElement("td"));
    this.fileNameCell.className = "FileName";
    this.fileNameCell.innerHTML = this.file.name;

    this.progressBar = new ProgressBar(1);
    this.progressBarCell = this.element.appendChild(document.createElement("td"));
    this.progressBarCell.appendChild(this.progressBar.element);

    this.actionCell = this.element.appendChild(document.createElement("td"));
  }

  this.cancel = function () {
    this.aborted = true;
    this.button.disabled = true;
    this.button.innerHTML = "Cancelled";
    this.element.classList.add("Cancelled");
  }

  this.createCancelButton = function (cancel) {
    this.button = document.createElement("button");
    this.button.innerHTML = "Cancel";
    this.button.className = "button";
    this.button.addEventListener(
      "click",
      (event) => {
        this.cancel();
        return false;
      }
    );

    this.actionCell.appendChild(this.button);
  }

  this.setProgress = function (progress, phase) {
    this.progressBar.setProgress(progress, phase);
  }

  this.element = element;
  this.file = file;

  this.aborted = false;
  this.build();
}

export class UploadArea extends FileDropZone {
  constructor(element) {
    super(element);

    this.build();
    this.initialize();
  }

  buildToolbar() {
    this.labels = new Labels(new DomQuery(this.element).getChild(WithClass("Labels")));

    const file = document.createElement("input");
    file.type = "file";

    const label = document.createElement("label");
    label.appendChild(file);
    label.appendChild(this.labels.Browse);

    const toolbar = document.createElement("div");
    toolbar.classList.add("Toolbar");
    toolbar.appendChild(this.labels.Upload);
    toolbar.appendChild(label);

    return toolbar;
  }

  build() {
    this.decoratedComponent = this.element.firstChild.component;
    this.name = this.decoratedComponent.name;

    const decoratedElement = this.element.firstChild;

    this.toolbar = this.buildToolbar();
    this.element.prepend(this.toolbar);

    this.fileInput = new DomQuery(this.toolbar).getDescendant(WithTagName("INPUT"));
    this.fileInput.multiple = true;
    this.fileInput.accept = this.element.dataset.Accept;
    this.fileInput.addEventListener(
      "input",
      (event) => {
        this.handleFiles(this.fileInput.files);
      }
    );

    this.uploadImage = this.element.insertBefore(document.createElement("div"), decoratedElement);
    this.uploadImage.className = "UploadImage";

    this.progressArea = this.element.insertBefore(document.createElement("div"), decoratedElement);
    this.progressArea.className = "ProgressArea";

    this.messages = this.element.insertBefore(document.createElement("ul"), decoratedElement);

    this.hidden = new HtmlClassSwitch(this.progressArea, "Hidden");
    this.hidden.setStatus(true);

    this.progressTable = this.progressArea.appendChild(document.createElement("table"));
    this.progressTable.className = "data";
    this.progressTable.appendChild(this.createTableHeaderRow());
  }

  save() {
    return this.decoratedComponent.save();
  }

  load(value) {
    this.decoratedComponent.load(value);
  }

  async createFile(file, uploadRow, callback) {
    const formData = new FormData();
    formData.append("FileName", file.name);
    formData.append("FileSize", file.size);

    const response = await fetch(
      this.URI,
      {
        method: "POST",
        body: formData
      }
    );

    if (response.ok && response.headers.get("content-type") === "application/json") {
      const body = await response.json();
      uploadRow.location = body.Target;

      this.processFile(file, uploadRow, callback);
    }
  }

  createFinalCallbackFunction(uploadRow, callback) {
    return () => {
      this.decoratedComponent.refresh();
      this.fireDataChanged();

      if (!uploadRow.aborted) {
        uploadRow.button.disabled = true;
        uploadRow.button.innerHTML = "Finished";
        uploadRow.element.classList.add("Finished");
      }

      if (callback !== null)
        callback();
    };
  }

  createProcessFileFunction(file, uploadRow, callback) {
    return () => {
      this.createFile(file, uploadRow, callback);
    };
  }

  createProcessFilePartFunction(part, uploadRow, callback) {
    return () => {
      this.processFilePart(part, uploadRow, callback);
    };
  }

  createTableHeaderRow() {
    const row = document.createElement("tr");

    const fileNameHeader = row.appendChild(document.createElement("th"));
    fileNameHeader.innerHTML = "File";

    const progressBarHeader = row.appendChild(document.createElement("th"));
    progressBarHeader.innerHTML = "Progress";

    const cancelButtonHeader = row.appendChild(document.createElement("th"));
    cancelButtonHeader.innerHTML = "Action";

    return row;
  }

  createUploadRow(file) {
    const element = this.progressTable.appendChild(document.createElement("tr"));
    element.className = "UploadRow";

    return new UploadRow(element, file);
  }

  handleEvent(event) {
    if (event instanceof FileUploadStatusChangedEvent && event.upload.target === this.URI && event.upload.state === FileUploadState.Submitted) {
      this.decoratedComponent.refresh();
      this.fireDataChanged();
    }
  }

  handleFiles(files) {
    if (this.shouldHandlePartitioned(files) || !('serviceWorker' in navigator))
      this.processFiles(files);
    else
      this.registerFiles(files);
  }

  shouldHandlePartitioned(files) {
    let result = this.allowPartitioning;

    if (result) {
      let index = 0;

      while (!result && index < files.length) {
        result = files[index].size > this.partSize;
        index++;
      }
    }

    return result;
  }

  initialize() {
    this.URI = this.element.dataset.Uri;
    this.maximumSize = parseInt(this.element.dataset.MaximumSize);
    this.allowPartitioning = this.element.dataset.AllowPartition === "true";

    if (this.allowPartitioning)
      this.partSize = parseInt(this.element.dataset.PartSize);
    else
      this.partSize = this.maximumSize;

    this.initializeDropZone();
  }

  async processFilePart(part, uploadRow, callback) {
    if (!uploadRow.aborted) {
      const formData = new FormData();
      formData.append("FileName", part.name);
      formData.append("Index", part.index);
      formData.append("Contents", part.blob);

      try {
        const response = await fetch(
          uploadRow.location,
          {
            method: "POST",
            body: formData
          }
        );

        if (response.ok) {
          const progress = (part.offset + part.blob.size) / uploadRow.file.size;
          uploadRow.setProgress([progress * 100], 0);
        }
      }
      finally {
        if (callback !== null)
          callback();
      }
    }
    else if (callback !== null)
      callback();
  }

  processFile(file, uploadRow, callback) {
    const reader = new FileReader();

    reader.onload = (event) => {
      const bytes = new Uint8Array(event.target.result);

      uploadRow.createCancelButton();

      const parts = new Array();
      let offset = 0;
      let remainder = file.size;

      while (remainder > 0) {
        const partSize = Math.min(remainder, this.partSize);
        parts.push({ "offset": offset, "size": partSize });

        offset += partSize;
        remainder = file.size - offset;
      }

      let callback_ = this.createFinalCallbackFunction(uploadRow, callback);

      for (let index = parts.length - 1; index >= 0; index--) {
        const part = parts[index];
        part.blob = new Blob([bytes.subarray(part.offset, part.offset + part.size)]);
        part.name = file.name;
        part.index = index;

        callback_ = this.createProcessFilePartFunction(part, uploadRow, callback_);
      }

      if (callback_ !== null)
        callback_();
    };

    reader.readAsArrayBuffer(file);
  }

  registerFile(file) {
    return new Promise((resolve, reject) => {
      if (!this.validateFile(file, this.element.dataset.Accept)) {
        application.fileStore.add({
          target: this.URI,
          name: file.name,
          contents: null,
          size: file.size,
          state: FileUploadState.Forbidden,
          attempts: 0,
          progress: 0,
          problems: [
            {
              Message: "Unsupported file type",
              Severity: "Error"
            }
          ],
          location: null,
          uuid: null
        });

        resolve();
      }
      else if (file.size > this.maximumSize) {
        application.fileStore.add({
          target: this.URI,
          name: file.name,
          contents: null,
          size: file.size,
          state: FileUploadState.Forbidden,
          attempts: 0,
          progress: 0,
          problems: [
            {
              Message: "Cannot upload file. File size over " + this.maximumSize / (1000 * 1000) + "MB",
              Severity: "Error"
            }
          ],
          location: null
        });

        resolve();
      }
      else {
        const reader = new FileReader();
        reader.onload = async (event) => {
          const fileData = {
            target: this.URI,
            name: file.name,
            contents: new Uint8Array(event.target.result),
            size: file.size,
            state: FileUploadState.Initial,
            attempts: 0,
            progress: 0,
            problems: [],
            location: null
          };

          await application.fileStore.add(fileData);

          const renderer = new ThumbnailRenderer();
          const thumbnail = await renderer.renderThumbnail(fileData);

          distributeEventDownHierarchy(
            new FileUploadedEvent(
              this,
              await application.pageHandler.persistThumbnail(fileData, thumbnail)
            ),
            this
          );

          resolve();
        };
        reader.onerror = (event) => {
          resolve();
        };
        reader.onabort = (event) => {
          resolve();
        };

        reader.readAsArrayBuffer(file);
      }
    });
  }

  registerFiles(files) {
    let task = new Promise(
      (resolve, reject) => {
        this.fileInput.disabled = true;
        resolve();
      }
    );

    for (const file of files)
      task = task.then(() => this.registerFile(file));

    task = task.then(() => {
      this.fileInput.value = null;
      this.fileInput.disabled = false;
    });
  }

  processFiles(files) {
    const uploadRows = new Array();

    for (let i = 0; i < files.length; i++)
      uploadRows.push(this.createUploadRow(files[i]));

    const listener = (event) => {
      event.preventDefault();
      return event.returnValue = "Are you sure you want to exit?";
    };

    window.addEventListener("beforeunload", listener);
    let callback = () => { window.removeEventListener("beforeunload", listener); };

    for (let index = files.length - 1; index >= 0; index--) {
      const file = files[index];
      const uploadRow = uploadRows[index];

      if (!this.validateFile(file, this.element.dataset.Accept))
        uploadRow.progressBarCell.innerHTML = "Unsupported file type";
      else if (file.size > this.maximumSize)
        uploadRow.progressBarCell.innerHTML = "Cannot upload file. File size over " + this.maximumSize / (1000 * 1000) + "MB";
      else
        callback = this.createProcessFileFunction(file, uploadRow, callback);
    }

    if (callback !== null)
      callback();
  }
}

interactivityRegistration.register("UploadArea", function (element) { return new UploadArea(element); });
